import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react'
import { useCMSContext } from './../../CMSContext'
// Material UI
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import { EncondingSectionType } from 'app/Constants/EncodingSectionType'
import './gallery.scss'
import ChooseImage from '../../../Shared/ChooseImage'
import OnlineVideos from '../../../Shared/OnlineVideos'
import ChooseVideo from '../../../Shared/ChooseVideo'
import GalleryActions from './galleryActions'
import { IARDialog } from '../../../Shared/Dialog/IARDialog'
import { videoTypes } from '../../../../Constants/videoTypes'
import { FaRegCheckCircle } from 'react-icons/fa'
import LoadingSpinner from '../../../Shared/LoadingSpinner/LoadingSpinner'
import ButtonSave from '../../../Shared/ButtonSave/ButtonSave'
import MediaThumbnail from '../../../Shared/MediaThumbnail/MediaThumbnail'
import MediaFilesMessage from '../../../Shared/MediaFilesMessage'
import Interceptor from '../../../../Services/serviceBase.interceptor'
import { useErrorSnackBarContext } from '../../../Shared/ErrorSnackBar/ErrorSnackBarContext'
import serviceBase from '../../../../Services/serviceBase'
import { useMenuSectionContext } from './../../MenuSection/MenuSectionContext'
import { CustomSwitch } from '../../../Shared/Switch/switch'
import { timeout } from '../../../../Constants/timeoutTypes'
import CMSActions from '../../CMSActions'
import { cloneDeep } from 'lodash'
import
{
  getOnlineVideosPayload,
  getImagesPayload,
  getVideosPayload,
  setNewEncodingPayload,
  asyncForEach,
  entitySetter
} from './galleryFunctions'
import PrepublishButtons from 'app/Components/Shared/PrepublishButtons/PrepublishButtons'
import galleryActions from './galleryActions'
import PreviewContentLabel from 'app/Components/Shared/PreviewContentLabel/PreviewContentLabel'

function Gallery({ fireDepartment })
{
  Interceptor.interceptor(useErrorSnackBarContext.actions)
  const { errorSnackBarActions } = useErrorSnackBarContext()

  const cmsContext = useCMSContext()
  const { socket, isReadOnlyMember, newVideoEncoding, iarMember, appConfiguration } =
    cmsContext.state

  const menuSectionContext = useMenuSectionContext()
  const { setDisableGalleryOption, setGalleryName } = menuSectionContext.actions

  const INITIAL_STATE = {
    sectionActive: false,
    sectionName: 'Gallery',
    images: [],
    onlineVideos: [],
    videos: [],
    fireDepartmentIdentifier: '',
    _id: ''
  }

  const [galleryEntity, setGalleryEntity] = useState(INITIAL_STATE)
  const [galleryEntityDiscard, setGalleryEntityDiscard] = useState(INITIAL_STATE)

  const [images, setImages] = useState([]) // this images is the one to be send in post
  const [videos, setVideos] = useState([]) // this images is the one to be send in post
  const [onlineVideos, setOnlineVideos] = useState([])
  const [deletedFiles, setDeletedFiles] = useState([]) // this images is the one to be send in post
  const [dialog, setDialog] = useState({ open: false })
  const [dataPosted, setDataPosted] = useState({ posted: false, message: '' })
  const [loading, setLoading] = useState(true)
  const [posting, setPosting] = useState(false)
  const [errorLabel, setErrorLabel] = useState('')
  const [disabledButton, setDisabledButton] = useState(true)
  const [deletedSeconds, setDeletedSeconds] = useState([])
  const [titleErrors, setTitleErrors] = useState('')

  const [showPublishedContent, setShowPublishedContent] = useState(true)
  const [tempUpdatedFiles, setTempUpdatedFiles] = useState([])

  //Properties for preview
  const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false)
  const [isDiscardDialogOpen, setIsDiscardDialogOpen] = useState(false)
  const [isPreviewDialogOpen, setIsPreviewDialogOpen] = useState(false)
  const [isPreviewNotSaveDialogOpen, setIsPreviewNotSavedDialogOpen] = useState(false)
  const [isDiscardedMedia, setIsDiscardedMedia] = useState(false)

  const previewedContentRef = useRef(INITIAL_STATE)
  const publishedContentRef = useRef(INITIAL_STATE)
  const previewDiscardContentRef = useRef(INITIAL_STATE)

  const isNewVideoEncodingProcessActive = useMemo(() =>
  {
    return (
      newVideoEncoding &&
      videos?.some((x) => !galleryEntityDiscard.videos.some((v) => v.fileName === x.fileName))
    )
  }, [newVideoEncoding, videos, galleryEntityDiscard.videos])

  useEffect(() =>
  {
    ; (async function ()
    {
      if (fireDepartment?.identifier)
      {
        const { previewed, published } = await getGalleryContent()
        previewedContentRef.current = previewed
        publishedContentRef.current = published
        previewDiscardContentRef.current = cloneDeep(previewed)
        if (!appConfiguration.previewEnabled) setShowPublishedContent(true)
      } else
      {
        setLoading(false)
      }
    })()
  }, [appConfiguration.previewEnabled, fireDepartment.identifier])

  useEffect(() =>
  {
    if (fireDepartment && socket)
    {
      socket.on(`${fireDepartment.fireDepartmentId.toString()}_inner_gallery`, (args) =>
      {
        console.log('CMS_inner_gallery', args, new Date())
        if (args.action === 'start')
        {
          setDisabledButton(true)
        }
        if (args.action === 'error' || args.action === 'nocontent')
        {
          setDisabledButton(false)
        }
        if (args.action === 'saved')
        {
          setDataPosted({ posted: true, message: 'Saved' })
          setPosting(false)
          if (args.response && args.memberId === iarMember.memberId)
          {
            previewDiscardContentRef.current = cloneDeep(args.response)
            if (args.isPreview)
            {
              previewedContentRef.current = args.response
            } else
            {
              publishedContentRef.current = args.response
            }
            //XOR validation
            //applies when show showPublishedContent is false and args.isPreview are true
            //applies when show showPublishedContent is true and args.isPreview are false
            if (!showPublishedContent === Boolean(args.isPreview))
            {
              setGalleryEntity(args.response)
              setGalleryEntityDiscard(cloneDeep(args.response))
              entitySetter(args.response, setImages, setVideos, setOnlineVideos)
            }
            setLoading(false)
          }
        }
      })
    }
    return () =>
    {
      socket.off(`${fireDepartment.fireDepartmentId.toString()}_inner_gallery`)
    }
  }, [socket, showPublishedContent])

  useEffect(() =>
  {
    if (errorLabel !== '')
    {
      errorSnackBarActions.setOpen(true, errorLabel)
    }
  }, [errorLabel])

  useEffect(() =>
  {
    if (!showPublishedContent && appConfiguration.previewEnabled)
    {
      setGalleryEntity(previewedContentRef.current)
      setGalleryEntityDiscard(cloneDeep(previewDiscardContentRef.current))
      entitySetter(previewedContentRef.current, setImages, setVideos, setOnlineVideos)
    } else
    {
      setGalleryEntity(publishedContentRef.current)
      setGalleryEntityDiscard(cloneDeep(publishedContentRef.current))
      entitySetter(publishedContentRef.current, setImages, setVideos, setOnlineVideos)
    }
  }, [showPublishedContent])

  useEffect(() =>
  {
    setDisabledButton(posting || (appConfiguration?.previewEnabled && showPublishedContent))
  }, [appConfiguration.previewEnabled, posting, showPublishedContent])

  const getGalleryContent = async () =>
  {
    let previewed = INITIAL_STATE
    const published = (await GalleryActions.fetchData(fireDepartment.identifier)) || INITIAL_STATE
    if (appConfiguration.previewEnabled)
    {
      previewed =
        (await GalleryActions.fetchPreviewData(fireDepartment.identifier)) || INITIAL_STATE
    }

    let entity = showPublishedContent ? published : previewed

    if (entity)
    {
      setGalleryEntity(entity)
      setGalleryEntityDiscard(cloneDeep(entity))
      entitySetter(entity, setImages, setVideos, setOnlineVideos)
    }

    setLoading(false)
    return { previewed, published }
  }

  const isReadyToSave = () =>
  {
    if (galleryEntity?.sectionName !== '') return true
    setTitleErrors('This field is required!')
    errorSnackBarActions.setOpen(true, 'Some fields are required')
    setTimeout(() =>
    {
      setTitleErrors('')
    }, timeout.fiveSeconds)
    setDataPosted({ ...dataPosted, posted: false })
    setPosting(false)
    setDisabledButton(false)
    return false
  }

  const sendGalleryPreview = async () =>
  {
    setDataPosted({ ...dataPosted, posted: false })
    setPosting(true)

    const online =
      onlineVideos?.map((v) => ({
        fireDepartmentIdentifier: fireDepartment.identifier,
        originalName: v.originalName,
        caption: v.caption,
        fileName: `${v.url}_${Date.now().toString()}`,
        type: 'online',
        provider: v.provider,
        url: v.url,
        fileSize: '',
        binary: v.binary
      })) ?? []

    let imagesPayload = []
    if (galleryEntity.images)
    {
      images.forEach((image) =>
      {
        let fileExists = !galleryEntityDiscard.images.some((i) =>
        {
          return i.fileName === image.fileName
        })

        if (fileExists)
        {
          imagesPayload.push({
            file: image.file,
            originalName: image.originalName,
            caption: image.caption,
            fileSize: image.fileSize,
            type: image.type
          })
        }
      })
    } else
    {
      imagesPayload = images
    }

    const img = []
    imagesPayload.forEach((image) =>
    {
      img.push({
        originalName: image.originalName,
        caption: image.caption,
        type: image.type,
        fileSize: image.fileSize,
        file: image.file
      })
    })

    const data = {
      fireDepartmentIdentifier: fireDepartment.identifier,
      images: img,
      videos: [],
      onlineVideos: online,
      filesToDelete: deletedFiles,
      filesToUpdate: tempUpdatedFiles,
      sectionActive: galleryEntity.sectionActive,
      sectionName: galleryEntity.sectionName
    }

    if (galleryEntity._id)
    {
      data._id = galleryEntity._id
    }

    const formData = new FormData()

    formData.append('request', JSON.stringify(data))

    images.forEach((image) =>
    {
      if (!image.file) return
      formData.append('images', image.file, image.originalName)
    })

    let readyToSave = isReadyToSave()
    if (!readyToSave) return

    try
    {
      const getResponse = await serviceBase.get(
        `${window._env_.COMMUNITY_API_URL}/gallery/emit-start/${fireDepartment.fireDepartmentId}`
      )
      if (getResponse.status !== 204)
      {
        return
      }
      const response = await serviceBase.post(
        `${window._env_.COMMUNITY_API_URL}/gallery-section-preview`,
        formData
      )
      if (response.status !== 200)
      {
        return
      }
      console.log('POST Gallery: ', response)

      setDataPosted({ posted: true, message: 'Saved' })
      setDeletedFiles([])
      setDeletedSeconds([])
    } catch (error)
    {
      errorSnackBarActions.setOpen(true)
      setDataPosted({ posted: false, message: 'Error while saving changes' })
      console.log(error)
    } finally
    {
      setPosting(false)
      setDisableGalleryOption(false)
      setDisabledButton(false)
      closePreviewDialog()
    }
  }

  const publishPost = async () =>
  {
    setIsSaveDialogOpen(false)
    setDataPosted({ ...dataPosted, posted: false })
    setPosting(true)
    galleryActions.postPublishGallery(galleryEntity?.fireDepartmentIdentifier).then(
      (data) =>
      {
        setGalleryName(data.sectionName)
        publishedContentRef.current = data
        previewDiscardContentRef.current = cloneDeep(data)
        previewedContentRef.current = data
        setGalleryEntity(data)
        setGalleryEntityDiscard(cloneDeep(data))
        setImages(data?.images ?? [])
        setVideos(data?.videos ?? [])
        setOnlineVideos(data?.onlineVideos ?? [])
        setDataPosted({ posted: true, message: 'Saved' })
        setDeletedSeconds([])
        setDeletedFiles([])
        console.log(`POST gallery section Response: ${data}`)
        setPosting(false)
        setDisableGalleryOption(false)
        setDisabledButton(false)
        callbackSuccessForPreview()
      },
      (err) =>
      {
        setErrorLabel('There was an error Publishing gallery section')
        errorSnackBarActions.setOpen(true, errorLabel)
        setPosting(false)
        setDisableGalleryOption(false)
        setDisabledButton(false)
      }
    )
  }

  const switchContent = () =>
  {
    if (!showPublishedContent)
    {
      previewedContentRef.current = {
        ...galleryEntity,
        videos,
        images,
        onlineVideos
      }
    }
    setShowPublishedContent((prev) => !prev)
    setDisabledButton((prevState) => !prevState)
  }

  const discardChanges = () =>
  {
    setDialog({ open: false })
    setGalleryEntity(cloneDeep(galleryEntityDiscard))
    setImages(cloneDeep(galleryEntityDiscard.images))
    setVideos(cloneDeep(galleryEntityDiscard.videos))
    setOnlineVideos(cloneDeep(galleryEntityDiscard.onlineVideos))
    setTempUpdatedFiles([])
    setIsDiscardedMedia((prev) => !prev)
    setDeletedFiles([])
    setDeletedSeconds([])
  }

  const renderSavedMessage = () =>
  {
    if (dataPosted.posted)
    {
      return (
        <div className="save-message">
          <FaRegCheckCircle className="check-circle" />
          <span className="save-message-text">{dataPosted.message}</span>
        </div>
      )
    }
  }

  const removeOnlineVideo = (file) =>
  {
    const files = deletedFiles

    files.push(file)
    const tempOnlineVideos = onlineVideos.filter((i) => i.originalName !== file.originalName)
    setOnlineVideos(tempOnlineVideos)
  }

  const removeAsset = (file, type) =>
  {
    switch (type)
    {
      case 'image':
        setDeletedFiles((prev) => [...prev, file.fileName])
        const tempImages = images.filter((i) => i.fileName !== file.fileName)
        setImages(tempImages)
        break
      case 'video':
        setDeletedFiles((prev) => [...prev, file.fileName])
        setDeletedSeconds((prev) =>
        {
          return [...prev, file.secondsDuration ?? 0]
        })
        const tempVideos = videos.filter((i) => i.fileName !== file.fileName)
        setVideos(tempVideos)
        break
      default:
        break
    }
  }

  const openConfirmationDialog = () =>
  {
    setDialog({ open: true })
  }

  const cancelDialog = () =>
  {
    setDialog({ open: false })
  }

  const saveGallery = async () =>
  {
    setDataPosted({ ...dataPosted, posted: false })
    setPosting(true)

    let videoPayload = []
    if (galleryEntity.videos)
    {
      videos.forEach((video) =>
      {
        if (video.binary)
        {
          videoPayload.push({
            originalName: video.FileName,
            caption: video.caption,
            type: video.type,
            fileSize: video.fileSize,
            binary: video.binary,
            secondsDuration: video.secondsDuration
          })
        }
      })
    } else
    {
      videoPayload = videos
    }

    let onlineVideoPayload = []
    if (galleryEntity.onlineVideos)
    {
      onlineVideoPayload = onlineVideos.map((v) =>
      {
        return {
          fireDepartmentIdentifier: fireDepartment.identifier,
          originalName: v.originalName,
          type: 'online',
          fileName: `${v.url}_${Date.now().toString()}`,
          provider: v.provider,
          caption: v.caption,
          fileSize: '',
          url: v.url
        }
      })
    } else
    {
      onlineVideoPayload = onlineVideos
    }

    const online = []
    onlineVideoPayload.forEach((elem) =>
    {
      online.push({
        fireDepartmentIdentifier: elem.fireDepartmentIdentifier,
        originalName: elem.originalName,
        caption: elem.caption,
        fileName: elem.fileName,
        type: elem.type,
        provider: elem.provider,
        url: elem.url,
        fileSize: elem.fileSize,
        binary: elem.binary
      })
    })

    let imagesPayload = []
    if (galleryEntity.images)
    {
      images.forEach((image) =>
      {
        let fileExists = !galleryEntity.images.some((i) =>
        {
          return i.fileName === image.fileName
        })

        if (fileExists)
        {
          imagesPayload.push({
            file: image.file,
            originalName: image.originalName,
            caption: image.caption,
            fileSize: image.fileSize,
            type: image.type
          })
        }
      })
    } else
    {
      imagesPayload = images
    }

    const img = []
    imagesPayload.forEach((image) =>
    {
      img.push({
        originalName: image.originalName,
        caption: image.caption,
        type: image.type,
        fileSize: image.fileSize,
        file: image.file
      })
    })

    const vid = []
    videoPayload.forEach((video) =>
    {
      vid.push({
        originalName: video.originalName,
        caption: video.caption,
        type: video.type,
        fileSize: video.fileSize,
        binary: video.binary,
        secondsDuration: video.secondsDuration
      })
    })

    const payload = {
      _id: galleryEntity._id || '',
      fireDepartmentIdentifier: fireDepartment.identifier,
      images: img,
      videos: vid,
      onlineVideos: online,
      filesToDelete: deletedFiles,
      filesToUpdate: tempUpdatedFiles,
      sectionActive: galleryEntity.sectionActive,
      sectionName: galleryEntity.sectionName,
      deletedSeconds: deletedSeconds
    }

    const formData = new FormData()

    formData.append('request', JSON.stringify(payload))

    videos.forEach((video) =>
    {
      if (video.binary === undefined) return

      formData.append('videos', video.binary, video.originalName)

      video.binary = null
    })

    images.forEach((image) =>
    {
      if (image.file === undefined) return

      formData.append('images', image.file, image.originalName)
      image.file = null
    })

    const readyToSave = isReadyToSave()
    if (!readyToSave) return

    try
    {
      const emitResponse = await serviceBase.get(
        `${window._env_.COMMUNITY_API_URL}/gallery/emit-start/${fireDepartment.fireDepartmentId}`
      )

      if (emitResponse.status !== 204) return
      setGalleryName(galleryEntity.sectionName)
      const response = await serviceBase.post(`${window._env_.COMMUNITY_API_URL}/gallery`, formData)

      setGalleryEntity(response.data)
      setGalleryEntityDiscard(cloneDeep(response.data))
      if (response.data.images.length > 0)
      {
        setImages(response.data.images)
      }
      if (response.data.videos.length > 0)
      {
        setVideos(response.data.videos)
      }
      if (response.data.onlineVideos.length > 0)
      {
        setOnlineVideos(response.data.onlineVideos)
      }

      setDataPosted({ posted: true, message: 'Saved' })
      setDeletedFiles([])
      setDeletedSeconds([])
      setTempUpdatedFiles([])
      console.log('POST Gallery: ', response)
    } catch (error)
    {
      errorSnackBarActions.setOpen(true)
      setDataPosted({ posted: false, message: 'Error while saving changes' })
      console.log(error)
    } finally
    {
      setPosting(false)
      setDisableGalleryOption(false)
    }
  }

  const updateAsset = (file) =>
  {
    let itemsUpdates = [...tempUpdatedFiles]
    if (tempUpdatedFiles.filter((el) => el.fileName === file.fileName).length > 0)
    {
      itemsUpdates.filter((el) => el.fileName === file.fileName)[0].caption = file.caption
    } else
    {
      itemsUpdates.push({ caption: file.caption, fileName: file.fileName })
    }
    setTempUpdatedFiles(itemsUpdates)
  }

  const sectionActiveChange = useCallback(() =>
  {
    setGalleryEntity((oldState) => ({
      ...oldState,
      sectionActive: !oldState.sectionActive
    }))
  }, [])

  const handleChange = (evt) =>
  {
    const value = evt.target.value
    const name = evt.target.name
    if (!showPublishedContent)
    {
      setGalleryEntity((oldState) => ({
        ...oldState,
        [name]: value
      }))
    }
    if (!appConfiguration.previewEnabled)
    {
      setGalleryEntity((galleryEntity) => ({
        ...galleryEntity,
        [name]: value
      }))
    }
  }

  const saveSectionVideoProcess = async (isPreview) =>
  {
    const { online } = getOnlineVideosPayload(onlineVideos, fireDepartment)
    const { img } = getImagesPayload(galleryEntityDiscard, images)
    const { vid } = getVideosPayload(galleryEntityDiscard, videos)
    const jsonData = setNewEncodingPayload(
      img,
      vid.length,
      online,
      isPreview ? EncondingSectionType.GalleryPreview : EncondingSectionType.Gallery,
      galleryEntity,
      deletedFiles,
      fireDepartment,
      images,
      iarMember,
      tempUpdatedFiles,
      galleryEntity.sectionActive,
      galleryEntity.sectionName,
      videos
    )
    const readyToSave = isReadyToSave()
    if (!readyToSave) return
    setPosting(true)
    closePreviewDialog()
    setDisabledButton(true)
    setDataPosted({ ...dataPosted, posted: false })
    await GalleryActions.getGalleryEmitStart(fireDepartment)
    const response = await CMSActions.saveSectionVideoProcess(jsonData)
    if (response !== 'error')
    {
      if (!isPreview) setGalleryName(galleryEntity.sectionName)
      let error = []
      async function fetchSaveVideoProcess(id, data)
      {
        await asyncForEach(data, async (v) =>
        {
          const payload = {
            sectionVideoId: id,
            originalName: v.originalName,
            caption: v.caption,
            fullusername: iarMember.fullName,
            secondsDuration: v.secondsDuration,
            fireDepartmentId: fireDepartment.fireDepartmentId,
            timezone: fireDepartment.timezone
          }
          const responseEncoder = await CMSActions.sendToEncoderVideo(
            fireDepartment.identifier,
            v,
            payload
          )
          if (!responseEncoder)
          {
            error.push(v.originalName)
          }

          if (error.length > 0)
          {
            setErrorLabel('Was an error uploading this files: ', error.join(','))
            errorSnackBarActions.setOpen(true, errorLabel)
            setPosting(false)
            closePreviewDialog()
            setDisabledButton(false)
            setDataPosted({ posted: false, message: 'Error while saving changes' })
          }
        })
      }
      fetchSaveVideoProcess(response._id, vid)
    }
  }

  const openPreviewDialog = () =>
  {
    setIsPreviewDialogOpen(true)
  }

  const closePreviewDialog = () =>
  {
    setIsPreviewDialogOpen(false)
  }

  const openNotSavedPreviewDialog = () =>
  {
    setIsPreviewNotSavedDialogOpen(true)
  }

  const closeNotSavedPreviewDialog = () =>
  {
    setIsPreviewNotSavedDialogOpen(false)
  }
  const openSaveDialog = () =>
  {
    setIsSaveDialogOpen(true)
  }

  const closeSaveDialog = () =>
  {
    setIsSaveDialogOpen(false)
  }

  const closeDiscardDialog = () =>
  {
    setIsDiscardDialogOpen(false)
  }

  const openDiscardDialog = () =>
  {
    setIsDiscardDialogOpen(true)
  }

  const callbackSuccessForPreview = () =>
  {
    setPosting(false)
  }

  const publishButtonValidations = () =>
  {
    if (
      JSON.stringify(galleryEntity) !== JSON.stringify(galleryEntityDiscard) ||
      JSON.stringify(videos) !== JSON.stringify(galleryEntity.videos) ||
      JSON.stringify(images) !== JSON.stringify(galleryEntity.images) ||
      JSON.stringify(onlineVideos) !== JSON.stringify(galleryEntity.onlineVideos)
    )
    {
      openNotSavedPreviewDialog()
    } else
    {
      openSaveDialog()
    }
  }

  const saveWithoutPreview = () =>
  {
    if (isNewVideoEncodingProcessActive) saveSectionVideoProcess(false)
    else saveGallery()
  }

  const savePreview = () =>
  {
    closePreviewDialog()
    if (isNewVideoEncodingProcessActive) saveSectionVideoProcess(true)
    else sendGalleryPreview()
  }

  return (
    <div className="App gallery">
      <IARDialog
        open={isPreviewNotSaveDialogOpen}
        title="Save Preview first"
        content="Please save your changes in preview before publishing"
        onOk={closeNotSavedPreviewDialog}
        onCancel={closeNotSavedPreviewDialog}
        previewNotSaved={true}
      />
      <div className="page-header" id="galleryTitle">
        Menu Section - {galleryEntity.sectionName}
      </div>
      {loading && <LoadingSpinner />}
      {!loading && (
        <>
          <IARDialog
            open={dialog.open}
            title="Confirm"
            content="Do you want to discard your changes?"
            onOk={discardChanges}
            onCancel={cancelDialog}
          />
          <Container maxWidth="lg">
            <Grid container spacing={2}>
              <Grid size={12}>
                <div className="page-description">
                  Your community will love to see you in action and to see more about what you do.
                  Use this page to upload images and videos in a “gallery” format. After uploading
                  your materials, you can add and edit captions for each image and/or video.
                </div>
              </Grid>
              <Grid size={12}>
                <form
                  onSubmit={(e) =>
                  {
                    e.preventDefault()
                  }}
                  className="page-content"
                  noValidate
                  autoComplete="off"
                >
                  <Grid container>
                    <Grid size={12} className="container-field">
                      {appConfiguration.previewEnabled && (
                        <div>
                          <span>Display Content as PREVIEW MODE</span>
                          <CustomSwitch
                            name="showPublished"
                            value={!showPublishedContent}
                            sectionActiveChange={switchContent}
                            useYesNoButtons={true}
                          />
                          <PreviewContentLabel
                            showPublished={showPublishedContent}
                            previewEnabled={appConfiguration.previewEnabled}
                          />
                        </div>
                      )}
                      <div>
                        <span>Section Visible on MyLS App</span>
                        <CustomSwitch
                          name="sectionActive"
                          value={Boolean(galleryEntity.sectionActive)}
                          sectionActiveChange={sectionActiveChange}
                          disabled={appConfiguration?.previewEnabled && showPublishedContent}
                          useYesNoButtons={true}
                        />
                      </div>
                    </Grid>
                  </Grid>

                  <br />
                  <Grid size={12} className="container-field">
                    <label htmlFor="sectionName">Section Name</label> <br />
                    <label htmlFor="error" className="error-text">
                      {titleErrors}
                    </label>
                    <TextField
                      id="sectionName"
                      name="sectionName"
                      variant="outlined"
                      className="form-control"
                      value={galleryEntity.sectionName}
                      onChange={handleChange}
                      disabled={appConfiguration.previewEnabled && showPublishedContent}
                    />
                  </Grid>
                  <br />
                  <Grid container>
                    <Grid size={12}>
                      <Grid className="container-field">
                        <label htmlFor="images" className="body-text">
                          Media Files
                        </label>
                        <MediaFilesMessage max={20}></MediaFilesMessage>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid size={{ xs: 12, md: 6 }} className="media-files">
                      <ChooseImage
                        images={images}
                        setImages={setImages}
                        fireDepartmentIdentifier={galleryEntity.fireDepartmentIdentifier}
                        max={20}
                        elementsAdded={images.length + videos.length}
                        isGalleryForm={true}
                        setErrorLabel={setErrorLabel}
                        isMessageEnabled={false}
                        disableHandleClick={appConfiguration.previewEnabled && showPublishedContent}
                      ></ChooseImage>
                      <>
                        {images.map((image, index) => (
                          <MediaThumbnail
                            isDiscardedMedia={isDiscardedMedia}
                            type="image"
                            key={[image.fileName, image.caption, index].join('-')}
                            media={image}
                            removeMediaEvent={removeAsset}
                            onUpdate={updateAsset}
                            disableHandleClick={
                              appConfiguration.previewEnabled && showPublishedContent
                            }
                          />
                        ))}
                      </>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }} className="media-files">
                      <ChooseVideo
                        videos={videos}
                        setVideos={setVideos}
                        fireDepartmentIdentifier={galleryEntity.fireDepartmentIdentifier}
                        max={20}
                        elementsAdded={images.length + videos.length}
                        isGalleryForm={true}
                        setErrorLabel={setErrorLabel}
                        isMessageEnabled={false}
                        disableHandleClick={appConfiguration.previewEnabled && showPublishedContent}
                      ></ChooseVideo>
                      <>
                        {videos.map((video, index) => (
                          <MediaThumbnail
                            isDiscardedMedia={isDiscardedMedia}
                            type="video"
                            key={[video.fileName, video.caption, index].join('-')}
                            media={video}
                            removeMediaEvent={removeAsset}
                            index={index}
                            onUpdate={updateAsset}
                            disableHandleClick={
                              appConfiguration.previewEnabled && showPublishedContent
                            }
                          />
                        ))}
                      </>
                    </Grid>
                    <Grid size={12} className="media-files">
                      <OnlineVideos
                        videos={onlineVideos}
                        setOnlineVideos={setOnlineVideos}
                        setErrorLabel={setErrorLabel}
                        max={5}
                        disableHandleClick={appConfiguration.previewEnabled && showPublishedContent}
                      />
                      {onlineVideos?.map((onlineVideo, index) => (
                        <MediaThumbnail
                          isDiscardedMedia={isDiscardedMedia}
                          type="online"
                          key={[onlineVideo.fileName, onlineVideo.caption, index].join('-')}
                          media={onlineVideo}
                          removeMediaEvent={removeAsset}
                          index={index}
                          subType={videoTypes.YoutubeVideos}
                          onUpdate={updateAsset}
                          removeOnlineVideo={removeOnlineVideo}
                          disableHandleClick={
                            appConfiguration.previewEnabled && showPublishedContent
                          }
                        />
                      ))}
                    </Grid>
                  </Grid>
                  <Grid size={12} className="container container-buttons">
                    {appConfiguration?.previewEnabled ? (
                      <PrepublishButtons
                        isDiscardDialogOpen={isDiscardDialogOpen}
                        isPreviewDialogOpen={isPreviewDialogOpen}
                        isReadOnlyMember={isReadOnlyMember}
                        isShown={appConfiguration.previewEnabled}
                        isSaveDialogOpen={isSaveDialogOpen}
                        openPreviewDialog={openPreviewDialog}
                        openDiscardDialog={openDiscardDialog}
                        closePreviewDialog={closePreviewDialog}
                        closeDiscardDialog={closeDiscardDialog}
                        closeSaveDialog={closeSaveDialog}
                        discardChanges={discardChanges}
                        disabledButton={disabledButton}
                        publishButtonValidations={publishButtonValidations}
                        posting={posting}
                        savePreview={savePreview}
                        savePublish={publishPost}
                      />
                    ) : (
                      <div className="save-button-container">
                        <ButtonSave
                          id="saveButton"
                          disabled={isReadOnlyMember || disabledButton}
                          loading={posting}
                          onClickCallback={saveWithoutPreview}
                        />
                        <Button
                          style={{ maxWidth: '250px', minWidth: '250px' }}
                          variant="outlined"
                          id="cancelButtonEntity"
                          disabled={isReadOnlyMember || disabledButton}
                          color="primary"
                          size="medium"
                          onClick={openConfirmationDialog}
                        >
                          Discard
                        </Button>
                        {renderSavedMessage()}
                      </div>
                    )}
                  </Grid>
                </form>
              </Grid>
            </Grid>
          </Container>
        </>
      )}
    </div>
  )
}

export default Gallery
